import _ from 'lodash';

let md5 = require('js-md5');

export default class Chat {
    static VERSION = 2;
    static ALIVE_INTERVAL = 20000;
    static TEAM_UPDATE_DELAY = 10000;
    static OFFLINE = 0;
    static ONLINE = 1;
    static ALL_TEAMS_ARE_OFLINE = 2;
    static OPERATOR = 0;
    static OPERATOR_NAME = 'Chat.OPERATOR';
    static OPERATOR_COLOR = '#000000';
    static OPERATOR_CALL_TIMEOUT = {
        now: 0,
        in: 1,
        beforeEventEnd: 2
    };

    static COLOR_BLACK = '#000000';
    static PLACEHOLDER_EVENT="{{{event_id}}}";
    static PLACEHOLDER_TOKEN="{{{auth_token}}}";

    constructor(uri, store, onConnectionClb) {

        
        this.wsuri = uri;
        this.conn = null;
        this.isConnected = false;
        this.teamOnlineStateDelayRefrences = new Array();
        this.store = store;

        this._onConnectionClb = onConnectionClb;
        this._positionClb = null;
        this._onlineClb = null;
        this._chatCreateClb = null;
        this._chatClb = null;
        this._chatActivationClb = null;
        this._authClb = null;
        this._opcallClb = null;
        this._opcallReceivedClb = null;
        this._messageReceivedClb = null;
        this._errorClb = null;
        this._updateClb = null;
        this._deleteClb = null;
        this._teamClb = null;
        this._broadcastClb=null;

        this._websocketOnlineStateClb = null;

        this._operatorToken = "";
        this._event_id = 0;

        this._semaphoreOnMessage = false;
        this._lastOfflineTime = null;
        this._startOnlineTime=null;
        window._timerID = 0;
        window._aliveTimerID = 0;

        this.beepmp3 = "/sounds/sound1.mp3";
        this.lastBeepTime = null;
        this.maxBeepInterval = 1000;
        this.volume=0.5;
        this.lastBeepPointer=null;


        this.queue=Array();
        this.queueLoop;
        this.isRunning=false;
        this._pauseConnection=false;
    }
    
    getConnectedEventId(){
        return this._event_id;
    }

    pushToQueue(item){
        this.queue.push(item);
        this.executeLoop();
    }

    executeLoop(self){
        self=(self)?self:this;
        if(!self.isRunning && self.conn != null && self.isConnected && !_.isEmpty(self.queue)){
            self.isRunning=true;
            while (self.queue.length>0){
                let item=self.queue.shift();
                if((typeof(item)=="string") && (Number(self._event_id)>0) && self._operatorToken!=""){
                    let modifiedItem=_.replace(item,Chat.PLACEHOLDER_EVENT,self._event_id);
                    modifiedItem=_.replace(modifiedItem,Chat.PLACEHOLDER_TOKEN,self._operatorToken);
                    
                    if(self.conn != null && self.isConnected && self.conn.readyState === WebSocket.OPEN){
                        console.log("Send: " + modifiedItem);
                        self.conn.send(modifiedItem);
                    }
                }
            }
        }else{
            console.log("WARNING: Can not send websocket message");
        }
        self.isRunning=false;
    }

    startLoop(){
        console.log('Start websocket loop');
        this.checkForUnsendMessagesAndAddToQueue();
        this.queueLoop=setInterval((this.executeLoop)(this),1000);
    }

    stopLoop(){
        console.log('Stop websocket loop');
        self.isRunning=false;
        clearInterval(this.queueLoop);
    }

    clearLoop(){
        console.log('Clear cached websocket requests');
        this.queue.length = 0;
        this.queue = [];
    }

    startWebsockets() {
        /*
        setTimeout(()=>{
        },3000);*/
        this._pauseConnection=false;
        if(!_.isEmpty(this.conn)){
            this.destroy();
        }
        console.log('Try to connect:'+this.wsuri);
        this.conn = new WebSocket(this.wsuri);
        let context = this;

        this.conn.onopen = function (e) {
            context._startOnlineTime=context.getCurrentTime();
            console.log(e);
            context.isConnected = true;
            console.log("Connection established!");


            if (window._timerID) {
                /* a setInterval has been fired */
                window.clearInterval(window._timerID);
                window._timerID = 0;
            }

            if (typeof (context._onConnectionClb) === "function") {
                context._onConnectionClb();
            }

            if (!window._aliveTimerID) {
                window._aliveTimerID = setInterval(function () {
                    context.sendAliveMessage();
                }, Chat.ALIVE_INTERVAL);
            }

            //Connection state
            if (typeof (context._websocketOnlineStateClb) === "function") {
                context._websocketOnlineStateClb(context.isConnected, context._lastOfflineTime);
            }
            context._lastOfflineTime = null;

        };

        this.conn.onclose = function (e) {
            
            console.log("Connection closed!");
            console.log(e);

            context.stopLoop();
            context.isConnected = false;
            context._lastOfflineTime = context.getCurrentTime();
            //try to reconnect in 3 seconds

            if (!window._timerID) {
                /* avoid firing a new setInterval, after one has been done */
                window._timerID = setInterval(function () {
                    if(!context._pauseConnection){
                        context.startWebsockets();
                    }
                }, 3000);
            }

            if (window._aliveTimerID) {
                /* a setInterval has been fired */
                window.clearInterval(window._aliveTimerID);
                window._aliveTimerID = 0;
            }

            if (typeof (context._websocketOnlineStateClb) === "function") {
                context._websocketOnlineStateClb(context.isConnected);
            }
        };

        this.conn.onmessage = function (e) {

            if (e === null || e.data === null) {
                console.log('WARNING: received data is null');
                return;
            }
            if (context._semaphoreOnMessage) {
                window.setTimeout(context.onMessage(e), 10);
            }
            context._semaphoreOnMessage = true;
            
            context.onMessage(e);
            context._semaphoreOnMessage = false;

        };

        this.conn.onerror = function (error) {
            console.log('WebSocket Error ' + JSON.stringify(error));
        };
    }

    closeRawConnection() {
        if (null !== this.conn) {
            this.conn.onclose = ()=> {};
            this.conn.close();

            if (typeof (this._websocketOnlineStateClb) === "function") {
                this._websocketOnlineStateClb(false);
            }
        }
        this.isConnected = false;
    }

    closeConnection(){
        if(this.conn){
            this.conn.onclose();
            this.closeRawConnection();
        }
    }

    pauseConnection(){
        this._pauseConnection=true;
        this.closeConnection();
    }

    destroy() {
        console.log('Destroy chat');
        //connection
        this.closeRawConnection();

        setTimeout(()=>{
            //give the cloding some time
            if (this.conn !== null) {
                this.conn.length = 0;
                this.conn = null;
            }
    
            clearInterval(window._timerID);
            this._event_id=0;
            this._operatorToken="";
            
            this.stopLoop();
            this.clearLoop(); 
        },300);

    }
    getOperatorId(){
        return Chat.OPERATOR;
    }
    onMessage(e) {
        let context = this;
        console.log("Receive: " + e.data);
        var data = JSON.parse(e.data);

        if (data.hasOwnProperty("type") && data.type === "error") {
            if (typeof (context._errorClb) === "function") {
                context._errorClb(data.key, data.message);
            }
            return;
        }

        if (!data.hasOwnProperty("type") || !data.hasOwnProperty("event") || !data.hasOwnProperty("message")) {
            console.log('WARNING: Unexpected json message: ', data);
            return;
        }

        var event = data.event;
        var message = data.message;

        switch (data.type) {
            case 'position':
                //{"type":"position","event":1,"message":{"teamid":"3","lat":123,"lng":456,"alt":789}}
                var properties = new Array("teamid", "lat", "lng", "alt", "speed", "bat", "visible");
                if (context.messageIsCorrect(message, properties, data.type)) {
                    
                    //Wenn es kein Array ist, dann eins daraus machen
                    var messageArray = context.getMessageAsArray(message);
                    for (var i = 0; i < messageArray.length; i++) {
                        if (context.objectIsNotNull(messageArray[i], properties)) {
                            // var name = context.getNameOfTeamId(messageArray[i].teamid);
                            // context.addNewTeamPosition(messageArray[i].teamid, name, messageArray[i].lat, messageArray[i].lng, messageArray[i].alt, messageArray[i].speed, messageArray[i].bat, messageArray[i].visible,messageArray[i].time);
                            // if (typeof (this._positionClb) === "function") {
                            //     context._positionClb(messageArray[i].teamid, name, messageArray[i].lat, messageArray[i].lng, messageArray[i].alt, messageArray[i].speed, messageArray[i].bat, messageArray[i].visible,messageArray[i].time);
                            // }
                        }
                    }
                }
                break;
            case 'online':

                //{"type":"online","event":1","message":{"teamname":"Operator","teamid":0,"online":true}}
                //{"type":"online","event":1","message":{["teamname":"Operator","teamid":0,"online":true}],[...]}
                var properties = new Array("teamname", "teamid", "online", "visible", "icon");

                if (context.messageIsCorrect(message, properties, data.type)) {

                    //Wenn es kein Array ist, dann eins daraus machen
                    let messageArray = context.getMessageAsArray(message);

                    //Alle empfangenen Teams zu hashmap this.teamMap hinzufügen
                    for (let i = 0; i < messageArray.length; i++) {

                        var msg = messageArray[i];
                        if (context.objectIsNotNull(msg, properties)) {
                            //var team = context.getTeam(msg.teamid);

                            context.updateTeamAndTriggerCallbacks(msg);
                            // Disabled delay of 10 seconds
                            /*
                            if ((team != null) && (team.teamid in context.teamOnlineStateDelayRefrences)) {
                                clearTimeout(context.teamOnlineStateDelayRefrences[team.teamid]);
                            }

                            if ((team != null) && !(context.toBoolean(msg.online))) {

                                context.teamOnlineStateDelayRefrences[team.teamid] = setTimeout(function () {
                                    //Take a delay of 10 seconds before show user offline in UI
                                    context.updateTeamAndTriggerCallbacks(msg);
                                }, Chat.TEAM_UPDATE_DELAY);
                            } else {
                                context.updateTeamAndTriggerCallbacks(msg);
                            }
                            */
                        }
                    }
                }
                break;
                case 'broadcast':

                    //{"type":"broadcast","event":1","message":{"test":"test"}}
                    if (typeof (context._broadcastClb) === "function") {
                        context._broadcastClb(message,event);
                    }
                    break;
            case 'team':

                //{"type":"team","event":1","message":{"teamname":"Operator","teamid":0,"online":true}}
                var properties = new Array("teamname", "teamid", "online", "visible", "icon");

                if (context.messageIsCorrect(message, properties, data.type)) {

                    //Wenn es kein Array ist, dann eins daraus machen
                    let messageArray = context.getMessageAsArray(message);

                    //Alle empfangenen Teams zu hashmap this.teamMap hinzufügen
                    for (let i = 0; i < messageArray.length; i++) {
                        if (context.objectIsNotNull(messageArray[i], properties)) {
                            //Doppelte Einträge werden aktualisiert
                            
                            context.addNewTeam(messageArray[i].teamid, messageArray[i].teamname, messageArray[i].online, messageArray[i].visible, messageArray[i].icon);

                            //Callbacks
                            if (typeof (context._teamClb) === "function") {
                                context._teamClb(messageArray[i].teamid, messageArray[i].teamname, messageArray[i].online, messageArray[i].visible, messageArray[i].icon);
                            }

                            //Chats, wo das Team drin ist aktualisieren-> Callback senden
                            var updatedChats = context.updateChatsByMember(messageArray[i].teamid);
                            if (typeof (context._updateClb) === "function" && updatedChats.length > 0) {
                                for (var k = 0; k < updatedChats.length; k++) {
                                    context._updateClb(updatedChats[k].token, updatedChats[k].name, updatedChats[k].members, updatedChats[k].online);
                                }
                            }

                        }
                    }
                }
                break;
            case 'chat_create':
                //{"type":"chat_create","event":1","message":{"chatname":"testroom","chattoken":"528c5e2239021","chatmember":[0,3],"chatonline":true}}
                var properties = new Array("chatname", "chattoken", "chatmember", "chatonline");
                if (context.messageIsCorrect(message, properties, data.type)) {
                    var memberArray = context.getMessageAsArray(message.chatmember);
                    var chat = context.addNewChat(message.chattoken, message.chatname, memberArray, message.chatonline);
                    context.fetchAllMessagesByChatIfEmpty(message.chattoken);
                    if (typeof (context._chatCreateClb) === "function") {
                        //console.log(chat.token + " " + chat.name + " " + chat.members + " " + chat.online);
                        context._chatCreateClb(chat.token, chat.name, chat.members, chat.online);
                    }
                }

                break;

            case 'chat_all':
                //{"type":"chat_all","event":1","message":[{"chatname":"testroom","chattoken":"528c5e2239021","chatmember":[0,3],"chatonline":true}]}
                /*
                var properties = new Array("chatname", "chattoken", "chatmember", "chatonline");

                if (context.messageIsCorrect(message, properties, data.type)) {
                    
                    //Wenn es kein Array ist, dann eins daraus machen
                    let messageArray = context.getMessageAsArray(message);
                    for (let i = 0; i < messageArray.length; i++) {
                        if (!context.objectIsNotNull(messageArray[i], properties)) {
                            messageArray.splice(i,1);
                        }
                    }
                }*/
                this.storeChats(_.values(message));
                this.sendGetAllChatMessages();

                break;
            case 'chat_update':

                //{"type":"chat_create","event":1","message":{"chatname":"testroom","chattoken":"528c5e2239021","chatmember":[0,3],"chatonline":true}}
                var properties = new Array("chatname", "chattoken", "chatmember", "chatonline");
                if (context.messageIsCorrect(message, properties, data.type)) {
                    var memberArray = context.getMessageAsArray(message.chatmember);
                    var chat = context.addNewChat(message.chattoken, message.chatname, memberArray, message.chatonline);
                    if (typeof (context._updateClb) === "function") {
                        //console.log(chat.token + " " + chat.name + " " + chat.members + " " + chat.online);
                        context._updateClb(chat.token, chat.name, chat.members, chat.online);
                    }
                }

                break;
            case 'chat_delete':

                //{"type":"chat_create","event":1","message":{"chatname":"testroom","chattoken":"528c5e2239021","chatmember":[0,3],"chatonline":true}}
                var properties = new Array("chatname", "chattoken", "chatmember", "chatonline");
                if (context.messageIsCorrect(message, properties, data.type)) {

                    context.deleteChat(message.chattoken);
                    if (typeof (context._deleteClb) === "function") {
                        context._deleteClb(message.chattoken);
                    }
                }

                break;
            case 'chat':
                //{"type":"chat","event":1","message":{"messagetoken":"abc","chattoken":"528c5e2239021","text":"hsgdhsghdgshgdhshd","from":3}}
                var properties = new Array("chattoken", "messagetoken", "text", "from", "time");
                if (context.messageIsCorrect(message, properties, data.type)) {

                    //Wenn es kein Array ist, dann eins daraus machen
                    let messageArray = context.getMessageAsArray(message);
                    for (let i = 0; i < messageArray.length; i++) {
                        if (context.objectIsNotNull(messageArray[i], properties)) {

                            var seen = (messageArray[i].hasOwnProperty("seen")) ? context.toBoolean(messageArray[i].seen) : true;

                            //Chatmessage speichern
                            if (!context.messageAlreadyReceived(messageArray[i].chattoken, messageArray[i].time, messageArray[i].from, messageArray[i].checksum)) {
                                context.insertChatMessage(messageArray[i].chattoken, messageArray[i].messagetoken, this.replaceBrByN(messageArray[i].text), messageArray[i].from, messageArray[i].time, messageArray[i].checksum, seen,true);

                                //Callback
                                if (typeof (context._chatClb) === "function") {
                                    context._chatClb(messageArray[i].chattoken, messageArray[i].messagetoken, this.replaceBrByN(messageArray[i].text), messageArray[i].from, messageArray[i].time, messageArray[i].checksum, seen);
                                }
                            }
                        }
                    }
                }

                break;
            case 'chat_activation':

                //{"type":"chat_activation","event":1,"message":{"chatonline":true,"chattoken":"sdjhsdbsjhduz"}}
                var properties = new Array("chattoken", "chatonline");
                if (context.messageIsCorrect(message, properties, data.type)) {

                    let chat = context.getChat(message.chattoken);
                    if (chat !== null) {
                        chat = context.addNewChat(chat.token, chat.name, chat.members, message.chatonline);
                        if (typeof (context._updateClb) === "function") {
                            context._updateClb(chat.token, chat.name, chat.members, chat.online);
                        }

                        if (typeof (context._chatActivationClb) === "function") {
                            context._chatActivationClb(message.chattoken, message.chatonline);
                        }

                    }

                }


                break;
            case 'auth':

                //{"type":"auth","event":1","message":{"token":"ahsg45gsnsjjh"}}
                var properties = new Array("token");
                if (context.messageIsCorrect(message, properties, data.type)) {
                    context._operatorToken = message.token;
                    context.startLoop();
                    if (typeof (context._authClb) === "function") {
                        context._authClb(message.token);
                    }
                }

                break;
            case 'opcall':
                //{"type":"opcall","event":1,"token":"MjEzODQ5MzkzODEuMzcyOQ==","message":{"team_ids":[0,3,5],"text":"aaaaaa"}}
                var properties = new Array("text", "time");
                if (context.messageIsCorrect(message, properties, data.type)) {

                    //Wenn es kein Array ist, dann eins daraus machen
                    var messageArray = context.getMessageAsArray(message);
                    for (var i = 0; i < messageArray.length; i++) {
                        if (context.objectIsNotNull(messageArray[i], properties)) {

                            var members = new Array();
                            if (messageArray[i].hasOwnProperty("team_ids")) {
                                members = messageArray[i].team_ids;
                            } else {
                                members = context.getAllTeamsIds();
                            }

                            //Opcall message in chat map speichern
                            context.addOpcallMessage(this.replaceBrByN(messageArray[i].text), members, messageArray[i].time, messageArray[i].checksum, false);
                            if (typeof (context._opcallClb) === "function") {
                                context._opcallClb(this.replaceBrByN(messageArray[i].text), members, messageArray[i].time, messageArray[i].checksum, false);
                            }
                        }
                    }

                }
                break;
            case 'opcall_received':
                //"type":"opcall_received","event":330,"message":{"checksum":"16ec114932520d2b9c18a28121d515af","team_id":3128,"chattoken":"hsjbdhsdsdjkb"}}
                var properties = new Array("chattoken", "checksum", "team_id");
                if (context.messageIsCorrect(message, properties, data.type)) {

                    /** Get last message with checksum and team_id*/

                    var chat = context.getChat(message.chattoken);
                    if (chat !== null) {
                        context.setOpMessageAsSeen(message.chattoken, Chat.OPERATOR, message.checksum);

                        if (typeof (context._opcallReceivedClb) === "function") {
                            context._opcallReceivedClb(message.chattoken, message.checksum, true);
                        }

                    }

                }
                break;


            case 'opcall_update':
                //Refresh list 
                //TODO: otherwise select by bc_id or id_operator_call and update values (text,team ids)
                this.sendGetAllOpCalls();
                break;
            case 'opcall_all_before':
                this.storeOpCallTemplates(_.values(message));
                break;
            case 'opcall_all':
                
                this.storeOpCalls(_.values(message));
                break;
            case 'opcall_delete':
                var msg_has_ids=context.messageIsCorrect(message, new Array("id_operator_call"), data.type);
                var msg_prop_broadcast_id = context.messageIsCorrect(message, new Array("bc_id"), data.type);

                if (msg_has_ids) {
                    let opcalls_to_delete=this.isArray(message.id_operator_call)?message.id_operator_call:new Array(message.id_operator_call);
                    for(let i in opcalls_to_delete){
                        this.deleteOpcall(opcalls_to_delete[i]);
                    }
                }else if(msg_prop_broadcast_id){
                    this.deleteOpcallByBroadcastId(message.bc_id);
                }else{
                    console.log('No id given to delete broadcast message');
                }
                
                break;
            case 'message_received':

                var properties = new Array("chattoken", "messagetoken","team_id");
                if (context.messageIsCorrect(message, properties, data.type)) {

                    /** Get last message with checksum and team_id*/

                    let chat = context.getChat(message.chattoken);
                    if (chat !== null) {
                        context.setMessageAsSeen(message.chattoken, message.team_id, message.messagetoken);

                        if (typeof (context._messageReceivedClb) === "function") {
                            context._messageReceivedClb(message.chattoken, message.team_id, message.messagetoken);
                        }
                    }
                }
                break;
                
        }

    };

    isSystemConnected() {
        return this.isConnected;
    }

    publish(value) {
        this.pushToQueue(value);
    }


    publishDirect(value){
        if(this.conn != null && this.isConnected && this.conn.readyState === WebSocket.OPEN){
            console.log("Send: " + value);
            this.conn.send(value);
        }
        
    }
    /*
     * Input: object,array of needed properties,messagetype
     * Return true,false
     */
    messageIsCorrect(obj, properties, type) {

        var objArray = new Array();

        if (!this.isArray(obj)) {
            objArray.push(obj);
        } else {
            objArray = obj;
        }


        for (var k = 0; k < objArray.length; k++) {
            for (var i = 0; i < properties.length; i++) {
                if (!objArray[k].hasOwnProperty(properties[i])) {
                    console.log('Warning: Unexpected json message. Need ' + properties[i] + ' for type: ' + type);
                    return false;
                }
            }
        }

        return true;
    }

    generatDummyMessage(chattoken, message, checksum){
        let obj = {
            message: message,
            checksum: checksum,
            chattoken: chattoken,
            messagetoken: this.getRandomOperatorMessageToken(), // need this to not overwrite messages in store
            seen: false,
            from: 0,
            isSending: true
        }

        this.storeMessage(obj);
    }

    createDummyChat(team){
        if(!_.isEmpty(team)){
            var obj = {
                token: null,
                name: team.name,
                members: [Chat.OPERATOR,Number(team.id_team)],
                online: Chat.ONLINE,
                unseenMessages: 0,
                lastActiveTime: 0
            };
            this.storeChat(obj);
        }
    }

    createDummyChats(){

        this.getAllTeams().forEach((team)=>{
           this.createDummyChat(team);
        });
    }

    objectIsNotNull(obj, properties) {
        for (var i = 0; i < properties.length; i++) {
            if (!obj.hasOwnProperty(properties[i]) || obj[properties[i]] === null || typeof (obj[properties[i]]) === 'undefined') {
                console.log('Warning: Object is null ' + obj);
                return false;
            }
        }
        return true;
    }

    /*
     * Teams der Hashmap this.teamMap hinzufügen - doppelte einträge aktualisieren
     */
    addNewTeam(id, name, online, visible, icon) {
        /*
        let team= (this.store.getters['teams/getItemById'](id));
        if(team){
            team.online = online;
            team.visible = visible;
            this.storeTeam(team);
        }else{
            //TODO: falls Daten nicht vorhanden neue holen ---> teamsBeahviour.reloadTeam
        }
        */
    }

    storeTeam(team){
        if(team){
            this.store.commit('teams/setObject', {
                id:'id_team',
                val:team
            });
        }else{
            console.log('Can not update team by given data');
        }
    }
    deleteTeam(teamId){
        if(teamId){
            this.store.commit('teams/deleteObject', {
                id:'id_team',
                index:teamId
            });
            return true;
        }
        console.log('Can not delete team');
        console.log(teamId);
        return false;
    }
    getTeam(id_team){
        return this.store.getters['teams/getItemById'](id_team);
    }

    addNewTeamPosition(id, name, lat, lng, alt, speed, bat, visible,time){
        let color = this.getColorOfTeamId(id);

        let obj = {
            "id_team":id,
            "name": name,
            "lat": lat,
            "lng": lng,
            "alt": alt,
            "speed": speed,
            "bat": bat,
            "visble": visible,
            "color": color,
            "time": time
        }

        if(obj){
            this.store.commit('teamPositions/setPositionObject', obj);
        }else{
            console.log('Can not update position by given data');
        }
    }

    updateChat(obj) {
       return this.store.commit('chatrooms/setObject', {
            id:'token',
            val:obj
        });
    }
    updateChatroomName(chattoken,chatname){
        if ((typeof (chatname) == 'string') && chatname.trim().length>0 ) {

            let chat = this.getChat(chattoken);

            if (!_.isEmpty(chat)) {           
                chat.chatname = chatname.trim();
                this.updateChat(chat);
                this.sendChatUpdateMessage(chatname,chattoken);
            }
        }
    }
    // removeChats() {
    //     if (null !== this.chatMap) {
    //         for (var i in this.chatMap) {
    //             this.chatMap[i].length = 0;
    //             this.chatMap[i] = null;
    //         }
    //         this.chatMap.length = 0;
    //         this.chatMap = null;
    //     }
    // };

    /* Team  */
    getNameOfTeamId(team_id) {
        let team = this.getTeam(team_id);
        return (team)?team.name:("Team "+team_id);
    }

    getOnlineStateOfTeamId(team_id) {

        let team = this.getTeam(team_id);
        return (team)?team.online:false;
    }

    getColorOfTeamId(team_id) {
        let team = this.getTeam(team_id);
        return (team)?team.color:Chat.COLOR_BLACK;
    }

    getIconOfTeamId(team_id) {
        let defaultTeamIcon = this.store.getters['chatrooms/getDefaultIcon'];
        if(null!=team_id){
            let team = this.getTeam(team_id);
            let defaultOperatorIcon = this.store.getters['chatrooms/getDefaultOperatorIcon'];
            if(team_id == Chat.OPERATOR){
                return defaultOperatorIcon;
            }else{      
                return (team)?team.teamPictureFile:defaultTeamIcon;
            }
        }
        return defaultTeamIcon;
    }
    getTeamIconByChat(chat){
        if(chat){
            let members = chat.members;   
            if(_.isArray(members) &&  members.length <= 2){
                let teamId = _.find(members, function(o) { return o !== Chat.OPERATOR});
                if(_.isEmpty(teamId)){
                    return this.getIconOfTeamId(teamId);
                }
            }else{
                return this.getIconOfTeamId(null);
            }
        }
        return this.getIconOfTeamId(null);
    }
    getAllTeams(){
        return this.store.getters['teams/getItems'];
    }

    getAllTeamsIds() {
        return _.map(this.getAllTeams(),'id_team');
    }

    updateTeamAndTriggerCallbacks(message) {

        //Doppelte Einträge werden aktualisiert
        this.addNewTeam(message.teamid, message.teamname, message.online, message.visible, message.icon);

        //Chats, wo das Team drin ist aktualisieren-> Callback senden
        var updatedChats = this.updateChatsByMember(message.teamid);

        //Callbacks
        if (typeof (this._onlineClb) === "function") {
            this._onlineClb(message.teamid, message.teamname, message.online, message.visible, message.icon);
        }
        if (typeof (this._updateClb) === "function" && updatedChats.length > 0) {
            for (var k = 0; k < updatedChats.length; k++) {
                this._updateClb(updatedChats[k].token, updatedChats[k].name, updatedChats[k].members, updatedChats[k].online);
            }
        }
    }

    getChatObject(chattoken, chatname, chatmember, chatonline){
        
        var obj = {
            token: chattoken,
            name: chatname,
            members: chatmember,
            online: this.toBoolean(chatonline),
            unseenMessages: 0,
            lastActiveTime: 0
        };
        //Chat online status setzen  
        var offlineByMembers = this.getAllMembersOfflineState(chatmember);
        if (chatonline && offlineByMembers) {
            obj.online = Chat.ALL_TEAMS_ARE_OFLINE;
        } else if (chatonline) {
            obj.online = Chat.ONLINE;
        } else if (!chatonline) {
            obj.online = Chat.OFFLINE;
        }
        return obj;
    }


    /*
     * Chat
     */

    /*
     * Chat der Hashmap this.chatMap hinzufügen - doppelte einträge aktualisieren
     * RETURN chat obj
     */
    addNewChat(chattoken, chatname, chatmember, chatonlineRaw) {
        var chatonline = chatonlineRaw ? Chat.ONLINE : Chat.OFFLINE;
        let obj=this.getChatObject(chattoken, chatname, chatmember, chatonline);
        let chat=this.getChatByMembers(chatmember);

        if(_.isEmpty(chat)){
            chat = this.getChat(chattoken);
        }

        if (!_.isEmpty(chat)) {
            obj.unseenMessages=chat.unseenMessages;
            obj.lastActiveTime=chat.lastActiveTime;
            obj = this.updateChat(obj);

        } else {
            /*
            if (chatonline && offlineByMembers) {
                obj.online = Chat.ALL_TEAMS_ARE_OFLINE;
            }*/
            this.storeChat(obj);
        }

        return obj;
    }

    storeChat(obj){
        return this.store.commit('chatrooms/setObject', {
            id:'token',
            val:obj
        });
    }

    storeChats(ar){
        if(_.isArray(ar)){

            let res=[];
            let context=this;
            ar.forEach((message)=>{
                
                if(!_.isEmpty(message)){
                    
                    let memberArray = context.getMessageAsArray(message.chatmember);
                    res.push(context.getChatObject(message.chattoken, message.chatname, memberArray, message.chatonline));
                }
            })

            return this.store.commit('chatrooms/setList', res);
        }
        
        console.log('Can not store chats. No array given.');
        return null;
    }
    
    storeOpCalls(ar){
        if(_.isArray(ar)){
            return this.store.commit('operatorCall/setList', ar);
        }
        
        console.log('Can not store opcalls. No array given.');
        return null;
    }

    storeOpCallTemplates(ar){
        if(_.isArray(ar)){
            return this.store.commit('operatorCallTemplates/setList', ar);
        }
        
        console.log('Can not store opcall templates. No array given.');
        return null;
    }
    
    deleteOpcall(id){
        if(id){
            this.store.commit('operatorCall/deleteObject', {
                id:'id_operator_call',
                index:id
            });
            return true;
        }
        console.log('Can not delete operator call');
        console.log(id);
        return false;
    }

    deleteOpcallByBroadcastId(id){
        if(id){
            this.store.commit('operatorCall/deleteObjects', {
                id:'bc_id',
                index:id
            });
            return true;
        }
        console.log('Can not delete operator call by broadcast id');
        console.log(id);
        return false;
    }

    deleteChat(chattoken) {
        if (typeof (chattoken) === "string") {
            this.store.commit('chatrooms/deleteObject', {
                id: 'token',
                index: chattoken
            });

            /** Delete chat history*/
            this.store.commit('chatmessages/deleteHistory', chattoken);

        }
    }


    // brauchen wir nichtmehr?
    getChat(token) {
        return null;
        //return this.store.getters['chatrooms/getItemByToken'](token);
    }
    getChats() {
        return [];
        //return this.store.getters['chatrooms/getItems'];
    }

    getMessages(){
        return this.store.getters['chatmessages/getItems'];
    }
    getMessageByMessageToken(token){
        return this.store.getters['chatmessages/getItemByMessageToken'](token);
    }
    checkForUnsendMessagesAndAddToQueue(){
        let unsendMessages=this.getUnSentChatMessages();
        if(unsendMessages){
            unsendMessages.forEach(m=>{
                this.sendChatMessage(m.chattoken, m.messagetoken, m.message);
            })
        }
    }
    deleteIsSendingMessage(chattoken,checksum,isSending){
        if(chattoken,checksum,isSending){
            this.store.commit('chatmessages/deleteIsSendingObject', {
                chattoken: chattoken,
                checksum: checksum,
                isSending: isSending
            });
            return true;
        }
        console.log('Can not delete message');
        return false;
    }
    getMessagesByChatToken(token){
        return _.sortBy(this.store.getters['chatmessages/getItemsByChatToken'](token),'time');
    }

    getUnseenMessagesByChatToken(token){
        return _.sortBy(this.store.getters['chatmessages/getUnseenItemsByChatToken'](token),'time');
    }

    getUnSentChatMessages(token){
        return _.sortBy(this.store.getters['chatmessages/getSendingMessages'](),'time');
    }

    fetchAllMessagesByChatIfEmpty(chattoken){
        if(_.isEmpty(this.getMessagesByChatToken(chattoken))){
            this.sendGetAllChatMessage(chattoken);
        }
    }
    storeMessage(obj){
        return this.store.commit('chatmessages/setObject', {
            id:'messagetoken',
            val:obj
        });
    }

    chatExists(memberArray) {
        if (!this.isMemberInArray(memberArray, Chat.OPERATOR)) {
            memberArray.push(Chat.OPERATOR);
        }
        var chat = this.getChatByMembers(memberArray);

        if (chat != null && chat.token!=null) {
            return true;
        }
        return false;
    }

    insertChatMessage(chattoken, messagetoken, message, from, time, checksum, seen,increaseNotification) {
        
        let chat = this.getChat(chattoken);
        if (!_.isEmpty(chat)) {
            
            
            time=Number(time);
            this.deleteIsSendingMessage(chattoken,checksum,true);

            var obj = {
                messagetoken: messagetoken,
                message: message,
                from: from,
                time: time,
                checksum: checksum,
                seen: seen,
                chattoken: chattoken
            };

            this.storeMessage(obj);
            
            if(increaseNotification && !this.toBoolean(seen) && from !=Chat.OPERATOR){
                this.increaseNotifications(chattoken,time);
            }else{
                this.setLastInteractionTime(chattoken,time);
            }

            
        }else{
            console.log('WARNING: Chatroom with ID: ' + chattoken + ' does not exists');
        }
    }

    increaseNotifications(chattoken, lastActiveTime){
        let chat = this.getChat(chattoken);
        if(chat){
            chat.unseenMessages++
            chat.lastActiveTime = Number(lastActiveTime);
            this.beepSavefty();
        }
        this.storeChat(chat);
    }
    setLastInteractionTime(chattoken, lastActiveTime){
        let chat = this.getChat(chattoken);
        if(chat){
            chat.lastActiveTime = Number(lastActiveTime);
        }
        this.storeChat(chat);
    }
    resetNotifications(chattoken){
        let chat = this.getChat(chattoken);
        if(chat){
            chat.unseenMessages = 0;
        }
        this.storeChat(chat);

        let unseenMessages=this.getUnseenMessagesByChatToken(chattoken);
        if(_.isArray(unseenMessages)){
            unseenMessages.forEach(m=>{
                if(m){
                    this.sendMessageReceived(chattoken,m.messagetoken,m.from);
                }
            })
        }

    }

    beepSavefty(){
        if(null!=this.lastBeepPointer){
            clearTimeout(this.lastBeepPointer);
        }
        this.lastBeepPointer=setTimeout(() => { this.beep();},100)
    }

    beep() {
        
        var now = new Date();
        if (this.lastBeepTime !== null && (now - this.lastBeepTime) < this.maxBeepInterval) {
            return;
        }
        this.lastBeepTime = now;
        // Setup the new Howl.
        const sound = new Howl({
            src: [this.beepmp3]
        });
        this.volume = this.volume ? this.volume : 0.5; // defaults to 50% volume level
        // Change global volume.
        Howler.volume(this.volume);
        
        // Fires when the sound finishes playing.
        sound.on('end', function(){
            this.pause();
            this.currentTime = 0;
        });
        
        // Play the sound.
        sound.play();

    }
    // removeMessages() {
    //     if (null !== this.messageMap) {
    //         for (var i in this.messageMap) {
    //             this.messageMap[i].length = 0;
    //             this.messageMap[i] = null;
    //         }
    //         this.messageMap.length = 0;
    //         this.messageMap = null;
    //     }
    // };

    /*
     * Checks if all members of an chat are offline
     * RETURN true/false
     */
    getAllMembersOfflineState(members) {
        if (typeof (members) === 'undefined' || members === null) {
            console.log('WARNING: Members var is null');
            return false;
        }

        if (members.length === 1 && members[0] == Chat.OPERATOR) {
            return false;
        }

        var team = null;
        for (var i = 0; i < members.length; i++) {
            team = this.getTeam(members[i]);
            if (!_.isEmpty(team)&& team.online && team.id !== Chat.OPERATOR) {
                return false;
            }
        }
        return true;

    }
    addOpcallMessage(message, memberA, time, checksum, seen) {
        var members = this.getMessageAsArray(memberA);
        //Suche privaten chatroom von jedem Member mit operator und schreibe nachricht in this.messageMap
        for (var i = 0; i < members.length; i++) {
            var chatMembers = new Array();
            chatMembers.push(Chat.OPERATOR);
            chatMembers.push(members[i]);


            var chat = this.getChatByMembers(chatMembers);
            if (chat !== null) {
                this.insertChatMessage(chat.token, this.getRandomOperatorMessageToken(), message, Chat.OPERATOR, time, checksum, seen,false);
            }
        }
    }

    replaceAll(find, replace, str) {
        return str.replace(new RegExp(find, 'g'), replace);
    }

    messageContainsHashtags(message, hashTags) {
        if (typeof (message) == "string" && typeof (hashTags) == "object") {
            for (var i in hashTags) {
                if (typeof (hashTags[i]) == "string") {
                    //wenn vor hashtag kein leerzeichen ist, dann einfügen
                    message = this.replaceAll("#", " #", message);

                    var startPos = message.toLowerCase().indexOf(hashTags[i].toLowerCase());
                    if ((typeof (message[i]) == "string") && (startPos > -1)) {
                        //is it the complete hashtag
                        var posNextWhiteSpace = message.toLowerCase().indexOf(" ", startPos);
                        var hashTagInMsgLength = (posNextWhiteSpace < 0) ? (message.length - startPos) : (posNextWhiteSpace - startPos);
                        if (hashTagInMsgLength == hashTags[i].length) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }

    getChatByMembers(memberArray,addOperator) {
        let chatrooms = this.getChats();
        var addOp =addOperator || false;
        if (this.isMemberInArray(memberArray, Chat.OPERATOR)) {
            addOp = true;
        }


        for (var i = 0; i < chatrooms.length; i++) {
            var chat = chatrooms[i];
            if (typeof (chat) === "undefined" || null === chat) {
                continue;
            }

            if (addOp && !this.isMemberInArray(chat.members, Chat.OPERATOR)) {
                chat.members.push(Chat.OPERATOR);
            }

            if (this.arrayIsEqual(chat.members, memberArray)) {
                return chat;
            }
        }


        return null;
    }

    getChatByTeamId(teamId) {
        let chatrooms = this.getChats();
        let members = [Number(teamId),Chat.OPERATOR];
        if(!_.isEmpty(chatrooms)){
         for(var i=0; i<chatrooms.length; i++){
             let chat = chatrooms[i];
            let chatroomMembers = chat.members.map(members=>{return Number(members)});
            if ( (_.difference(chatroomMembers,members).length == 0) && _.difference(members,chatroomMembers).length == 0){
                return chat;
            }
         }
        }
        return null;
    }
    getAllChatsByTeamId(teamId) {
        let chatrooms = this.getChats();
        if(!_.isEmpty(chatrooms)){
            let chats = [];
            for(var i=0; i<chatrooms.length; i++){
                let chat = chatrooms[i];
                let chatroomMembers = chat.members.map(members=>{return Number(members)});
                let checkedMemberArray = chatroomMembers.filter(member => {
                    return (Number(member) == Number(teamId))
                })
                if (!_.isEmpty(checkedMemberArray)){
                    chats.push(chat);
                }
            }
            return chats;
        }
        return null;
    }

    /*
     * Returns all chats where the teamid is member
     */
    getAllChatsofMember(teamid) {
        let chatrooms = this.getChats();
        var res = Array();
        for (var i = 0; i < chatrooms.length; i++) {
            if (typeof (chatrooms[i]) !== "undefined" && null !== chatrooms[i] && this.isMemberInArray(chatrooms[i].members, teamid)) {
                res.push(chatrooms[i]);
            }
        }

        return res;
    }

    getOperatorChatTokenByMember(memberIds) {
        let chatrooms = this.getChats();
        var memberIdsAr = this.isArray(memberIds) ? memberIds : new Array(memberIds);
        var res = [];
        if (null != chatrooms) {
            for (var i = 0; i < chatrooms.length; i++) {
                var chat = chatrooms[i];
                if (typeof (chat) === "undefined" || null === chat) {
                    continue;
                }

                for (var k in memberIdsAr) {
                    var memberId = memberIdsAr[k];
                    if ((chat.members.length <= 2) && (chat.members.indexOf(memberId) > -1)) {
                        res.push(chat.token);
                    }
                }
            }
        }

        return res;
    }

    getOnlineStateOfChat(chattoken) {

        var chat = this.getChat(chattoken);
        if (chat !== null) {
            return chat.online;
        } else {
            return false;
        }
    }

    getMembersOfChat(chattoken) {
        var res = Array();
        var chat = this.getChat(chattoken);
        if (chat !== null) {
            return chat.members;
        } else {
            return res;
        }
    }
    isMemberInArray(chatmembers, teamid) {
        if(_.isArray(chatmembers)){
            for (var i = 0; i < chatmembers.length; i++) {
                if (chatmembers[i] == teamid)
                    return true;
            }
        }
        return false;
    }


    /*
     * Callbacks
     */

    //this.isConnected, this._lastOfflineTime
    setWebsocketOnlineStateClb(clb) {
        this._websocketOnlineStateClb = clb;
    }

    //id,name,lat,lng,alt,speed,bat,visible
    setPositionClb(clb) {
        this._positionClb = clb;
    }
    //teamid,teamname,online,visible,icon
    setOnlineClb(clb) {
        this._onlineClb = clb;
    }

    //teamid,teamname,online,visible,icon
    setTeamClb(clb) {
        this._teamClb = clb;
    }

    //chattoken,chatname,chatmember,chatonline
    setChatCreateClb(clb) {
        this._chatCreateClb = clb;
    }

    //chattoken,messagetoken,text,from,time
    setChatClb(clb) {
        this._chatClb = clb;
    }

    //chattoken,chatonline
    setChatActivationClb(clb) {
        this._chatActivationClb = clb;
    }

    //token
    setAuthClb(clb) {
        this._authClb = clb;
    }

    //text,team_ids
    setOpcallClb(clb) {
        this._opcallClb = clb;
    }

    //checksum,team_id
    setOpcallReceivedClb(clb) {
        this._opcallReceivedClb = clb;
    }

    //key,error
    setErrorClb(clb) {
        this._errorClb = clb;
    }

    //token,name,members,online
    setChatUpdateClb(clb) {
        this._updateClb = clb;
    }

    //chattoken
    setChatDeleteClb(clb) {
        this._deleteClb = clb;
    }

    setBroadcastClb(clb){
        this._broadcastClb=clb;
    }

    isArray(obj) {
        if (Object.prototype.toString.call(obj) === '[object Array]') {
            return true;
        }
        return false;
    }

    /*
     * Stellt sicher, dass Objekt ein Array ist
     */
    getMessageAsArray(message) {
        //Wenn es kein Array ist, dann eins daraus machen

        var messageArray = null;
        if (!this.isArray(message)) {
            messageArray = new Array();
            messageArray.push(message);
        } else {
            messageArray = message;
        }
        return messageArray;
    }

    /*
     * Finds the Id of the Operator in the given array
     */
    findOperator(teamArray) {

        for (var i = 0; i < teamArray.length; i++) {
            if (teamArray[i] == Chat.OPERATOR) {
                return i;
            }
        }
        return -1;
    }

    arrayIsEqual(a1, a2) {
        return !(a1.sort() > a2.sort() || a1.sort() < a2.sort());
    }

    /*
     * Send Actions
     */

    //Login for Operators
    loginAsOperator(username, password, event_id) {
        this._event_id = event_id;
        this.publishDirect('{"type":"auth","event":' + this._event_id + ',"v":' + Chat.VERSION + ',"token":"","message":{"email":"' + username + '","password":"' + password + '"}}');
    }

    //Login
    login(token, event_id) {
        this._event_id = event_id;
        this._operatorToken = token;
        this.publishDirect('{"type":"online","event":' + this._event_id + ',"v":' + Chat.VERSION + ',"token":"'+token+'","message":{"online":true, "info":false}}');
    }

    //Logout
    logout() {
        this.publishDirect('{"type":"online","event":' + this._event_id + ',"v":' + Chat.VERSION + ',"token":"'+this._operatorToken+'","message":{"online":false,"info":false}}');
    }

    broadcast(jsonMessage,receiveBroadcast=false,broadcastToAllTeamsInEvent=false, type='broadcast') {
        jsonMessage=(typeof(jsonMessage)=="object")?jsonMessage:((typeof(jsonMessage)=="string")?JSON.parse(jsonMessage):null);
        if(_.isEmpty(jsonMessage)){
            console.warn('no broadcast data to send');
            return;
        }
        jsonMessage['include_me']=receiveBroadcast;
        jsonMessage['broadcast_to_all']=broadcastToAllTeamsInEvent;
        this.publishDirect('{"type":"' + type + '","event":' + this._event_id + ',"v":' + Chat.VERSION + ',"token":"'+this._operatorToken+'","message":'+JSON.stringify(jsonMessage)+'}');
    }


    /*
     * Input: array members
     */
    createChat = function (chatName, members) {

        var memberArray = this.getMessageAsArray(members);
        memberArray=memberArray.map(x => Number(x));

        if (!this.chatExists(memberArray)) {
            //this.sendChatCreateMessage(chatName, members);

            this.publish('{"type":"chat_create","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"team_ids":' + JSON.stringify(memberArray) + ',"chatname":"' + chatName + '"}}');
            return true;
        }
        return false;
    }

    sendGetAllChatRooms=function(){
        this.publish('{"type":"chat_all","event":' + Chat.PLACEHOLDER_EVENT + ',"v":' + Chat.VERSION + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{}}');
    }

    /*
     * Updates chat online state by team online state and returns chats array obj or null
     */
    updateChatsByMember(teamid) {

        //Operator auschließen
        if (teamid == Chat.OPERATOR) {
            return new Array();
        }

        var chats = this.getAllChatsofMember(teamid);
        for (var i = 0; i < chats.length; i++) {
            var onlineResult = chats[i].online;
            var offlineByMembers = this.getAllMembersOfflineState(chats[i].members);

            if (chats[i].online && offlineByMembers) {
                onlineResult = Chat.ALL_TEAMS_ARE_OFLINE;
            } else if (chats[i].online == Chat.ALL_TEAMS_ARE_OFLINE && !offlineByMembers) {
                onlineResult = Chat.ONLINE;
            }
            /*else if (chats[i].online && !offlineByMembers) {
             onlineResult = chats[i].online;
             }
             else{
             onlineResult = Chat.ALL_TEAMS_ARE_OFLINE;
             }
             */

            chats[i].online = onlineResult;

            //(Re)name Chat by Teamname
            if (chats[i].members.length === 2 && this.isMemberInArray(chats[i].members, Chat.OPERATOR)) {
                var team = this.getTeam(teamid);
                if (team != null) {
                    chats[i].name = team.name;
                }
            }

        }

        return chats;
    }

    enableChat(chatToken) {
        this.setChatOnline(chatToken, true);
    }

    disableChat(chatToken) {
        this.setChatOnline(chatToken, false);

    }

    setChatOnline(chatToken, enable) {
        this.publish('{"type":"chat_activation","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"chatonline":' + enable + ',"chattoken":"' + chatToken + '"}}');
    }

    sendChatMessage(chatToken, chatMessageToken, message) {
        message = this.removeInvalidCharacters(message);
        this.generatDummyMessage(chatToken, message, md5(message));
        this.publish('{"type":"chat","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"chattoken":"' + chatToken + '","messagetoken":"' + chatMessageToken + '","text":"' + message + '"}}');
    }

    sendAliveMessage() {
        this.publishDirect('{"type":"alive"}');
    }

    sendGetAllTeamPositionsMessage(includingHistory) {
        //{"type":"position_all","event":1,"token":"NDIxMzgyNjI1OTEzLjk0","message":{}}
        let history=(includingHistory)?'':'"last_pos":true';
        this.publish('{"type":"position_all","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{'+history+'}}');
    }

    sendGetAllChatMessage(chattoken, time) {
        //{"type":"messages_all","event":1,"token":"NDIxMzgyNjI1OTEzLjk0","message":{}}
        //optionaler message parameter: time, include_opcalls

        var msg_chattoken = '';
        if (typeof (chattoken) !== 'undefined' && chattoken !== null) {
            msg_chattoken = '"chattoken":"' + chattoken + '"';
        }

        if (typeof (time) !== 'undefined' && time !== null) {
            msg_chattoken = msg_chattoken + ' "time":"' + time + '"';
        }

        this.publish('{"type":"messages_all","event":' + Chat.PLACEHOLDER_EVENT+ ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{' + msg_chattoken + '}}');
    }

    sendGetAllMissedChatMessages(forceTime) {
        let chatrooms = this.getChats();
        var force = (typeof (forceTime) != "undefined" && null != forceTime);
        if (force || (this._lastOfflineTime !== null && this._lastOfflineTime > 0)) {
            var time = (force) ? this.getCurrentTime(forceTime) : this._lastOfflineTime;
            for (var k = 0; k < chatrooms.length; k++) {
                if (typeof (chatrooms[k]) !== "undefined" && null !== chatrooms[k]) {
                    this.sendGetAllChatMessage(chatrooms[k].token, time);
                }
            }
        }
    }

    sendGetAllChatMessages() {
        let chatrooms = this.getChats();
        for (var k = 0; k < chatrooms.length; k++) {
            if (typeof (chatrooms[k]) !== "undefined" && null !== chatrooms[k]) {
                this.sendGetAllChatMessage(chatrooms[k].token);
            }
        }
    }

    sendGetAllTeamOnlineStates() {
        this.publish('{"type":"team_all","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{}}');
    }

    sendTeamRefresh() {
        this.publish('{"type":"team_refresh","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{}}');
    }

    storeOpCall(message, team_ids, startTime){
        let operatorId = this.getRandomOperatorMessageToken();
        let obj = {
            id_operator_call: operatorId,
            name: "operator",
            text: message,
            start: startTime,
            team_id: team_ids,
            isTemp: true
        }

        this.store.commit('operatorCall/setObject', {
            id:'id_operator_call',
            val:obj
        });
    }

    sendOperatorCallUpdate(message, team_ids,operatorcall_id,bc_id,time){
        message = this.removeInvalidCharacters(message);
        let team_ids_str = this.getTeamStringForWsMessage(team_ids);
        let bcStr=(bc_id)?(',"bc_id":"' + bc_id+'"'):"";
        let idOperatorCallString=(operatorcall_id)?(',"operatorcall_id":' + operatorcall_id):"";

        this.publish('{"type":"opcall_update","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"text":"' + message + '"' + ', "time":"'+time+'"'+' ' + team_ids_str + ' ' + bcStr  + idOperatorCallString +'}}');
    }

    sendGetLatestOperatorCalls(event_ids){

        this.publish('{"type":"opcall_all_before","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"event_ids":' + JSON.stringify(event_ids) + '}}');
    }

    sendOperatorCall(message, team_ids, startTimeMode, startTime, repeatCounter, repeatDelay, isBroadcast) {
        //{"type":"opcall","event":1,"token":"MjEzODQ3NjU2NDEuMjM3Mw==","message":{"text":"sssssss"}}
        //{"type":"opcall","event":1,"token":"MjEzODQ5MzkzODEuMzcyOQ==","message":{"team_ids":[0,3,5],"text":"aaaaaa", "beforeEnd":10}}

        let broadCastString = '"broadcast":'+((isBroadcast)?true:false);

        message = this.removeInvalidCharacters(message);
        let chat = this.getChatByMembers(team_ids);
        if(chat){
            this.generatDummyMessage(chat.token, message, md5(message));
        }
        //Teams
        let team_ids_str = this.getTeamStringForWsMessage(team_ids);

        //Intervall und Startzeit
        //Zeit umrechnen
        startTime = startTime * 60; //Umrechnng in sekunden
        let startTimeStr = this.getStartTimeString(startTimeMode, startTime);

        this.publish('{"type":"opcall","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"text":"' + message + '"' + ' ' + team_ids_str + ' ' + startTimeStr + ' ,' + broadCastString +'}}');

        //Wiederholungen
        var intervalStartTime = 0;
        for (var i = 0; i < repeatCounter; i++) {
            intervalStartTime = this.getIntervalTime(startTimeMode, startTime, i, repeatDelay);
            startTimeStr = this.getStartTimeString(startTimeMode, intervalStartTime);
            //this.publish
            if (intervalStartTime >= 0) {
                this.publish('{"type":"opcall","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"text":"' + message + '"' + ' ' + team_ids_str + ' ' + startTimeStr  + ' ,' + broadCastString +'}}');
            }
        }
        
        //Refresh list
        this.sendGetAllOpCalls();
    }

    getTeamStringForWsMessage(team_ids){
        let team_ids_str = "";
        if (typeof (team_ids) !== 'undefined') {
            team_ids = this.getMessageAsArray(team_ids);
            //Operator aus array löschen
            var id_op = this.findOperator(team_ids);
            if (id_op > -1) {
                team_ids.splice(id_op, 1);
            }

            team_ids_str = ',"team_ids":' + JSON.stringify(team_ids);
        }

        return team_ids_str;
    }

    createId() {
        // use current timestamp to avoid duplicate IDs
        
         let minMax = [1000,9999];
         let rand= Math.floor( Math.random() * ( minMax[1] - minMax[0] + 1 ) ) + minMax[0];
         return Date.now()+rand;

        // uuid creates non unique ids
        // return +uuid().replace(/\D/g,'').substr(0,5);
    }

    transformDateToWsDate(date) {
        return this.getCurrentTime(date);
    }

    getStartTimeString(startTimeMode, startTime) {
        var startTimeStr = "";
        if ((startTimeMode == Chat.OPERATOR_CALL_TIMEOUT.now) || (startTimeMode == Chat.OPERATOR_CALL_TIMEOUT.in)) {
            if (startTime > 0) {
                startTimeStr = ',"in":' + startTime;
            }
        } else if (startTimeMode == Chat.OPERATOR_CALL_TIMEOUT.beforeEventEnd) {
            startTimeStr = ',"beforeEnd":' + startTime;
        }
        return startTimeStr;
    }
    getIntervalTime(startTimeMode, startTime, i, repeatDelay) {
        var intervalStartTime = 0;
        if ((startTimeMode == Chat.OPERATOR_CALL_TIMEOUT.now) || (startTimeMode == Chat.OPERATOR_CALL_TIMEOUT.in)) {
            intervalStartTime = startTime + (i + 1) * repeatDelay * 60;
        } else if (startTimeMode == Chat.OPERATOR_CALL_TIMEOUT.beforeEventEnd) {
            intervalStartTime = startTime - (i + 1) * repeatDelay * 60;
        }
        return intervalStartTime;
    }

    sendChatCreateMessage(chatname, team_ids) {
        //{"type":"chat_create","event":1,"token":"MjEzODQ5NDA1MjQuNjQ4NA==","message":{"team_ids":[3],"chatname":"testroom"}}
        team_ids = JSON.stringify(team_ids);
        var team_ids_str = "";
        if (typeof (team_ids) !== 'undefined') {
            team_ids = this.getMessageAsArray(team_ids);
            team_ids_str = ',"team_ids":' + team_ids;
        }

        this.publish('{"type":"chat_create","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"chatname":"' + chatname + '"' + ' ' + team_ids_str + '}}');
    }

    sendTeamAddMessage(chattoken, team_ids) {
        if(_.isArray(team_ids) && team_ids.length > 0){
            team_ids = JSON.stringify(team_ids);
            var team_ids_str = "";
            if (typeof (team_ids) !== 'undefined') {
                team_ids = this.getMessageAsArray(team_ids);
                team_ids_str = ',"chatmember":' + team_ids;
            }

            this.publish('{"type":"chat_team_add","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"chattoken":"' + chattoken + '"' + ' ' + team_ids_str + '}}');
        }
    }    

    sendChatUpdateMessage(chatname,chattoken) {

        if ((typeof (chatname) == 'string') && chatname.trim().length>0 ) {
            this.publish('{"type":"chat_update","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"chatname":"' + chatname + '","chattoken":"' + chattoken + '"}}');
        }else{
			console.warn('Chatname can not be empty');
		}  
    }

    sendChatDeleteMessage(chattoken) {
        this.publish('{"type":"chat_delete","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"chattoken":"' + chattoken + '"}}');
    }

    removeTeamOfChatrooms(teamId){
        let context = this;
        let chats = this.getAllChatsByTeamId(teamId);
        if(!_.isEmpty(chats)){
            chats.forEach(chat => {
                context.sendTeamDeleteMessage(chat.token, [teamId]);
            });
        }
    }

    sendTeamDeleteMessage(chattoken, team_ids) {
        if(_.isArray(team_ids) && team_ids.length > 0){
            team_ids = JSON.stringify(team_ids);
            var team_ids_str = "";
            if (typeof (team_ids) !== 'undefined') {
                team_ids = this.getMessageAsArray(team_ids);
                team_ids_str = ',"chatmember":' + team_ids;
            }
    
            this.publish('{"type":"chat_team_remove","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"chattoken":"' + chattoken + '"' + ' ' + team_ids_str + '}}');
        }
    }

    sendMyTeamMessage() {
        this.publish('{"type":"my_team","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{}}');
    }
    
    sendGetAllOpCalls(){
        this.publish('{"type":"opcall_all","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"broadcast":true}}');
    }
    
    sendUpdateOpCall(){
        //TODO -> delete und neuen opcall anlegen
    }
    
    sendDeleteOpCall(ids){

        if(!_.isEmpty(ids)){
            let ids_str=this.getMessageAsArray(ids);
            this.publish('{"type":"opcall_delete","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"id_operator_call":"' + ids_str + '"}}');
        }else{
            console.warn('Can not delete operator call')
        }
    }

    sendDeleteOpCallByBroadcastId(id){

        if(!_.isEmpty(id)){
            this.publish('{"type":"opcall_delete","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"bc_id":"' + id + '"}}');
        }else{
            console.warn('Can not delete operator call')
        }
    }

    sendMessageReceived(chattoken,messagetoken,teamId){
        
        if(teamId == Chat.OPERATOR){
            return false;
        }

        if(null==messagetoken || null==chattoken || null==teamId){
            console.warn('Can not confirm chat message. Token is empty');
            return false;
        }
        this.publish('{"type":"message_received","event":' + Chat.PLACEHOLDER_EVENT + ',"token":"' + Chat.PLACEHOLDER_TOKEN + '","message":{"messagetoken":"' + messagetoken + '","team_id":'+teamId+',"chattoken":"' + chattoken + '"}}');
    }

    getRandomOperatorMessageToken(){
        let minMax = [1000,9999];
        let rand= Math.floor( Math.random() * ( minMax[1] - minMax[0] + 1 ) ) + minMax[0];
        return Date.now()+rand;
    }

    getRandomOperatorId(){
        this.getRandomOperatorMessageToken();
    }

    messageAlreadyReceived(chattoken, time, from, checksum) {
        var messages = this.getMessagesByChatToken(chattoken)
        for (var i = 0; i < messages.length; i++) {
            if (messages[i].time == time && messages[i].from == from && messages[i].checksum == checksum) {
                return true;
            }
        }
        return false;
    }

    setOpMessageAsSeen(chattoken, from, checksum) {
        var messages = this.getMessagesByChatToken(chattoken)
        for (var i = 0; i < messages.length; i++) {
            
            if (messages[i].from == from && messages[i].checksum == checksum && messages[i].seen !== true) {
                messages[i].seen = true;
                this.storeMessage(messages[i])
                return true;
            }
        }
        return false;
    }

    setMessageAsSeen(chattoken, from, messagetoken) {
        var messages = this.getMessagesByChatToken(chattoken)
        for (var i = 0; i < messages.length; i++) {
            
            if (messages[i].from == from && messages[i].messagetoken == messagetoken && messages[i].seen !== true) {
                messages[i].seen = true;
                this.storeMessage(messages[i])
                return true;
            }
        }
        return false;
    }

    getCurrentTime(date) {
        //20131216130053
        var currentdate = (typeof (date) != "undefined" && null != date) ? date : new Date();
        var datetime = currentdate.getFullYear() +
            ('0' + (currentdate.getMonth() + 1)).slice(-2) +
            ('0' + (currentdate.getDate())).slice(-2) +
            ('0' + (currentdate.getHours())).slice(-2) +
            ('0' + (currentdate.getMinutes())).slice(-2) +
            ('0' + (currentdate.getSeconds())).slice(-2);

        return datetime;

    }

    getTimeFormat(time, includeDate) {
        time=String(time);
        var yyyy = this.pad(time.substring(0, 4));
        var mm = this.pad(time.substring(4, 6));
        var dd = this.pad(time.substring(6, 8));
        var hh = this.pad(time.substring(8, 10));
        var mi = this.pad(time.substring(10, 12));
        var ss = this.pad(time.substring(12, 14));
        if (includeDate) {
            return dd + '.' + mm + '.' + yyyy + ' ' + hh + ':' + mi + ':' + ss;
        }
    
        return hh + ':' + mi + ':' + ss;
    }

    getIsoTimeFormat(time){
        //2011-10-10T14:48:00
        time=String(time);
        var yyyy = time.substring(0, 4);
        var mm = this.pad(time.substring(4, 6));
        var dd = this.pad(time.substring(6, 8));
        var hh = this.pad(time.substring(8, 10));
        var mi = this.pad(time.substring(10, 12));
        var ss = this.pad(time.substring(12, 14));
        return yyyy + '-' + mm + '-' + dd + 'T' + hh + ':' + mi + ':' + ss;
    }

    getDateFormat(time){
        time=String(time);
        var yyyy = time.substring(2, 4); // remove first 2 digits
        var mm = this.pad(time.substring(4, 6));
        var dd = this.pad(time.substring(6, 8));
        return dd + '.' + mm + '.' + yyyy;
    }

    getTimeDifference(time1,time2){
        time1=(time1)?time1:this.getCurrentTime();
        time2=(time2)?time2:this.getCurrentTime();
        return Number(time2)-Number(time1);
    }

    timeIsMoreThanOneDayInPast(time,time2){
        let minTimeDiffBetween1Day=764041;
        return this.timeIsInPast(time,time2,minTimeDiffBetween1Day);
    }
    timeIsMoreThan3MinutesInPast(time,time2){
        let minTimeDiffBetween1Day=180;
        return this.timeIsInPast(time,time2,minTimeDiffBetween1Day);
    }
    timeIsInPast(time,time2,timeDiffInSeconds){
        let minTimeDiff=(timeDiffInSeconds)?timeDiffInSeconds:0;
        time2=(time2)?time2:null;
        return (time)?(this.getTimeDifference(time,time2)>=minTimeDiff):false;
    }

    pad(n) {
        var res = n < 10 ? '0' + n : n;
        return res.length > 2 ? res.slice(res.length - 2, res.length) : res;
    }

    removeInvalidCharacters(str) {
        //Replace double quotes with single quotes
        str= str.replace(/"/g, "'");
        return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

    replaceBrByN(str){
        return str;
        /*
        if(_.isString(str)){
            return str.replace(/<br ?\/?>/ig,"\n");
        }
        return str;
        */
    }



    toBoolean(str) {
        if (typeof (str) === "boolean") {
            return str;
        } else if (typeof (str) === "string") {
            switch (str.toLowerCase()) {
                case "true":
                case "yes":
                case "1":
                    return true;
                case "false":
                case "no":
                case "0":
                case null:
                    return false;
                default:
                    return false;
            }
        } else if (typeof (str) === "number") {
            return Boolean(str);
        } else {
            return false;
        }
    }




    //KOnstruktor

    //startWebsockets();
};

// Chat.OFFLINE = 0;
// Chat.ONLINE = 1;
// Chat.ALL_TEAMS_ARE_OFLINE = 2;
// Chat.OPERATOR = 0;
// Chat.OPERATOR_NAME = TGTranslation.operator;
// Chat.OPERATOR_COLOR = '#000000';
// Chat.OPERATOR_CALL_TIMEOUT = {
//     now: 0,
//     in: 1,
//     beforeEventEnd: 2
// };

// Chat.aliveInterval = 20000;